import { UserAuthorityDTO } from 'types/User';
import { axiosInstance } from '../shared/axios/axiosConfig';
import { CN_MGMT_API_URL } from './constants';

/**
 * Fetch the list of authorities
 */
const getNoteAuthorities = async () => {
  try {
    const response = await axiosInstance.get(`${CN_MGMT_API_URL}/user-authorities/read`);
    return response.data;
  } catch {
    return { ...[], authorityList: [] };
  }
};

export const fetchUserAuthorities = async () => {
  const noteAuthorities = await getNoteAuthorities();
  return {
    note: [...noteAuthorities.authorityList],
  } as UserAuthorityDTO;
};

const authorityService = { getNoteAuthorities };
export default authorityService;
